<template>
    <v-container fluid>
        <product-form
            :model="model"
            @saved="saved"
            :titlePrefix="$t('forms.title_prefix.add')"
        >
        </product-form>
    </v-container>
</template>

<script>
import Product from '@/models/product/Product'
import ProductForm from './Form'

export default {
    components: {
        ProductForm,
    },

    data: () => {
        return {
            product: new Product(),
        }
    },

    computed: {
        model() {
            let model = this.product
            return model
        },
    },

    methods: {
        saved() {
            this.$router.go(-1)
        },
    },
}
</script>

<style></style>
